import { FC, memo, useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Book, BookmarkAPI, Project } from '@brg/api';
import { useToasts } from '@brg/ui'
import { IconWrapperSpecial2 } from 'shared/assets/styles';
import { useDispatch, useSelector } from "react-redux";
import { CurrentProjectActions, CurrentProjectSelector } from "../../reducers/CurrentProject";
import {BookmarksIcon} from "../../icons/projectToolsWithResize/BookmarksIcon";
import {BookmarksFillIcon} from "../../icons/projectToolsWithResize/BookmarksFillIcon";
import { useProfile } from '@brg/auth';

type PropsT = {
  project: Project | Book;
  entityType: string;
  entityId: string;
  inActiveState?: boolean;
};

const BookmarkButton: FC<PropsT> = ({ project, entityId, entityType, inActiveState }) => {
  const { t } = useTranslation();
  const toasts = useToasts();
  const dispatch = useDispatch();
  const profile = useProfile();

  const bookmarkedLocally = useSelector(CurrentProjectSelector)?.projectStatus?.[entityId]?.isBookmarked;

  const isBookChapter = useMemo(() => (project && !!project?.bookId?.length), [project]);

  const setLocalStatus = (status: boolean) => {
    dispatch(CurrentProjectActions.setBookmarked({id: entityId, status }));
  }

  useEffect(() => {
    if (!project) return;

    // @ts-ignore
    setLocalStatus(isBookChapter ? project?.book?.isBookmark : project?.isBookmark)
  }, [project, entityId, entityType, isBookChapter]);


  const handleClick = useCallback(() => {
    if (inActiveState) return null;
    if (!profile?.accountId) {
      toasts.error(t('NEED_AUTHORIZATION'));
      return;
    }

    const id = isBookChapter ? project?.bookId : entityId;
    const method = bookmarkedLocally ? 'RemoveBookmark' : 'Bookmark';

    BookmarkAPI[method]({ entityId: id, entityType })
      .then(() => {
        if (isBookChapter) {
          toasts.info(t(`book_edit.frames.book_bookmark_${method.toLowerCase()}`));
          setLocalStatus(!bookmarkedLocally);
          return;
        }
        setLocalStatus(!bookmarkedLocally);
      })
      .catch(() => {
        toasts.error(t('NEED_AUTHORIZATION'));
      })
  }, [bookmarkedLocally, t, entityId, entityType, toasts, inActiveState, isBookChapter, profile]);

  return (
    <IconWrapperSpecial2
      pressed={bookmarkedLocally}
      fullFill
      onClick={handleClick}
    >
      {bookmarkedLocally ? (
          <BookmarksFillIcon/>
      ) : (
          <BookmarksIcon />
      )}
    </IconWrapperSpecial2>
  )
};

export default memo(BookmarkButton)

import { FC, memo, useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Book, BookmarkAPI, Project } from '@brg/api';
import { useToasts } from '@brg/ui'
import { IconWrapperSpecial2 } from 'shared/assets/styles';
import { useDispatch, useSelector } from "react-redux";
import { CurrentProjectActions, CurrentProjectSelector } from "../../reducers/CurrentProject";
import {BookmarksIcon} from "../../icons/projectToolsWithResize/BookmarksIcon";
import {BookmarksFillIcon} from "../../icons/projectToolsWithResize/BookmarksFillIcon";
import { useProfile } from '@brg/auth';

type PropsT = {
  project: Project | Book;
  entityType: string;
  entityId: string;
  inActiveState?: boolean;
};

const BookmarkButton: FC<PropsT> = ({ project, entityId, entityType, inActiveState }) => {
  const { t } = useTranslation();
  const toasts = useToasts();
  const dispatch = useDispatch();
  const profile = useProfile();

  const bookmarkedLocally = useSelector(CurrentProjectSelector)?.projectStatus?.[entityId]?.isBookmarked;

  const isBookChapter = useMemo(() => (project && !!project?.bookId?.length), [project]);

  const setLocalStatus = (status: boolean) => {
    dispatch(CurrentProjectActions.setBookmarked({id: entityId, status }));
  }

  useEffect(() => {
    if (!project) return;

    // @ts-ignore
    setLocalStatus(isBookChapter ? project?.book?.isBookmark : project?.isBookmark)
  }, [project, entityId, entityType, isBookChapter]);


  const handleClick = useCallback(() => {
    if (inActiveState) return null;
    if (!profile?.accountId) {
      toasts.error(t('NEED_AUTHORIZATION'));
      return;
    }

    const id = isBookChapter ? project?.bookId : entityId;
    const method = bookmarkedLocally ? 'RemoveBookmark' : 'Bookmark';

    BookmarkAPI[method]({ entityId: id, entityType })
      .then(() => {
        if (isBookChapter) {
          toasts.info(t(`book_edit.frames.book_bookmark_${method.toLowerCase()}`));
          setLocalStatus(!bookmarkedLocally);
          return;
        }
        setLocalStatus(!bookmarkedLocally);
      })
      .catch(() => {
        toasts.error(t('NEED_AUTHORIZATION'));
      })
  }, [bookmarkedLocally, t, entityId, entityType, toasts, inActiveState, isBookChapter, profile]);

  return (
    <IconWrapperSpecial2
      pressed={bookmarkedLocally}
      fullFill
      onClick={handleClick}
    >
      {bookmarkedLocally ? (
          <BookmarksFillIcon/>
      ) : (
          <BookmarksIcon />
      )}
    </IconWrapperSpecial2>
  )
};

export default memo(BookmarkButton)

